import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';

// import { Button } from '../Button';
// // import Rating from '../Rating';

const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: linear-gradient(355.51deg, #4bbdac -15.27%, #016585 98.54%),
    linear-gradient(2.37deg, #0eccb0 13.46%, #006788 65.39%), #cf1b53;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    flex-direction: row;
    justify-content: space-between;
    padding: 40px 60px;
  }
`;
const StyledText = styled(Box)`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 36px;
  line-height: 120%;
  color: #ffffff;
`;

// const RatingContainer = styled(Flex)`
//   display: none;
//   @media only screen and (min-width: ${HOMEPAGE_BREAKPOINT_DESKTOP}) {
//     display: block;
//   }
// `;

export const Banner = (): ReactElement => {
  return (
    <Container>
      <StyledText>Courses</StyledText>
      {/* <RatingContainer>
        <Rating />
      </RatingContainer> */}
    </Container>
  );
};
